var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentTyIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 7.99984C1.33331 5.64152 1.33331 4.46235 2.03518 3.6751C2.14744 3.54919 2.27117 3.43274 2.40495 3.32708C3.2414 2.6665 4.49426 2.6665 6.99998 2.6665H8.99998C11.5057 2.6665 12.7586 2.6665 13.595 3.32708C13.7288 3.43274 13.8525 3.54919 13.9648 3.6751C14.6666 4.46235 14.6666 5.64152 14.6666 7.99984C14.6666 10.3582 14.6666 11.5373 13.9648 12.3246C13.8525 12.4505 13.7288 12.5669 13.595 12.6726C12.7586 13.3332 11.5057 13.3332 8.99998 13.3332H6.99998C4.49426 13.3332 3.2414 13.3332 2.40495 12.6726C2.27117 12.5669 2.14744 12.4505 2.03518 12.3246C1.33331 11.5373 1.33331 10.3582 1.33331 7.99984Z",
    stroke: "#212129",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 10.6665H7.66669",
    stroke: "#212129",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66669 10.6665H12",
    stroke: "#212129",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33331 6H14.6666",
    stroke: "#212129",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTyIc);
export default __webpack_public_path__ + "static/media/payment_ty_ic.95371d48733bf7e772d74adc637b9e5a.svg";
export { ForwardRef as ReactComponent };